import type { ReactNode } from "react";

interface RowProps {
  readonly label?: string;
  readonly value: ReactNode;
  /** A quiet line under the value — what the row will actually give you. */
  readonly note?: string;
  readonly onClick?: () => void;
  /** Display face for a headline; body face for a fact. */
  readonly serif?: boolean;
  readonly trailing?: ReactNode;
}

/**
 * A hairline-separated row. This is what replaces the pastel card: structure
 * from a rule and a type change rather than from a tinted box.
 */
export function Row({ label, value, note, onClick, serif = true, trailing }: RowProps) {
  const content = (
    <div className="flex w-full items-start gap-3 border-b border-rule py-3 text-left">
      <div className="min-w-0 flex-1">
        {label && <p className="label mb-1">{label}</p>}
        <div className={serif ? "font-display text-[17px] leading-[1.35]" : "text-[15px] leading-[1.5]"}>
          {value}
        </div>
        {note && <p className="mt-0.5 text-[12.5px] leading-[1.5] text-mid">{note}</p>}
      </div>
      {trailing}
    </div>
  );
  if (!onClick) return content;
  return (
    <button type="button" onClick={onClick} className="block w-full text-ink">
      {content}
    </button>
  );
}
